export const getStringSet = () => {
  return {
    LIST_HEADER_TITLE: 'Live events',
    LIST_HEADER_BUTTON: 'Go Live',
    LIST_EMPTY_DESCRIPTION: 'No live events',
    NO_LIVE_EVENT_TITLE: 'No live events selected',
    NO_LIVE_EVENT_DESCRIPTION: 'Select a live event from the list or create a live event',
    EVENT_STATUS_CREATED: 'UPCOMING',
    EVENT_STATUS_READY: 'OPEN',
    EVENT_STATUS_ONGOING: 'LIVE',
    EVENT_STATUS_ENDED: 'ENDED',
    PARTICIPANT_COUNT: (participantCount: number) => `${participantCount}K`,
    LIST_HOST_NICKNAME_PLACEHOLDER: '—',
    LIVE_EVENT_ENTER_ROLE_DIALOG_TITLE: 'Choose your role',
    LIVE_EVENT_ENTER_ROLE_DIALOG_OPTION_HOST: 'Host',
    LIVE_EVENT_ENTER_ROLE_DIALOG_OPTION_PARTICIPANT: 'Participant',
    LIVE_EVENT_ENTER_ALERT_TITLE: `Can't enter yet`,
    LIVE_EVENT_ENTER_ALERT_DESCRIPTION: 'This live event will open soon.',
    LIVE_EVENT_CREATE_HEADER_TITLE: 'New live event',
    LIVE_EVENT_CREATE_EVENT_TITLE: 'Title',
    LIVE_EVENT_CREATE_EVENT_TITLE_PLACEHOLDER: 'Add a title',
    CREATE_EVENT_DEFAULT_TITLE: `'s audio live`,
    LIVE_EVENT_CREATE_EVENT_USERS_FOR_HOST: 'Users who can be host',
    LIVE_EVENT_CREATE_EVENT_COVER_IMAGE_TITLE: 'Cover image',
    LIVE_EVENT_CREATE_EVENT_COVER_IMAGE_BUTTON: 'Upload photo',
    LIVE_EVENT_CREATE_HEADER_BUTTON: 'Create',
    LIST_USERS_FOR_HOST_HEADER_TITLE: 'Users who can be host',
    ADD_USERS_FOR_HOST_HEADER_TITLE: 'Users',
    ADD_USERS_FOR_HOST_HEADER_BUTTON: 'Add ${}',
    USER_FOR_HOST_NICKNAME: (nickname: string) => `${nickname} (You)`,
    USER_ID_PLACEHOLDER: 'Enter user ID',
    ADD_USERS_FOR_HOST_DIALOG_TITLE: 'Add user',
    NICKNAME: 'Nickname',
    USER_ID: 'User ID',
    USER_SEARCH_USER_COUNT_LIMIT: (count: number) => ` / 10 users`,
    USER_SEARCH_USER_COUNT_DESCRIPTION: 'You can add up to 10 users to be host.',
    USER_SEARCH_EXACT_MATCH_DESCRIPTION: 'Only an exact match can be found.',
    USER_SEARCH_NO_MATCH_DESCRIPTION: (keyword: string) => `No matches found with "{keyword}"`,
    USER_SEARCH_NO_USERS_DESCRIPTION: 'There are no users.',
    USER_SEARCH_ERROR_DESCRIPTION: 'Something went wrong. Try again.',
    USER_SEARCH_COUNT_EXCEED_DESCRIPTION: `Can't add more than 10 users`,
    START_LIVE_EVENT_HEADER_BUTTON: 'Start live event',
    LIVE_EVENT_PARTICIPANT_COUNT: (participantCount: number) => `${participantCount}`,
    LIVE_EVENT_MESSAGE_INPUT_PLACEHOLDER: 'Enter message',
    LIVE_EVENT_INFORMATION_TITLE: 'Live event information',
    HOST: 'Host',
    PARTICIPANTS: 'Participants',
    FREEZE_CHAT: 'Freeze chat',
    FREEZE_CHAT_DESCRIPTION: 'Only operators can send a message. This doesn\'t stop the live event.',
    LIVE_EVENT_ID: 'Live event ID',
    CREATED_AT: 'Created on',
    CREATED_BY: 'Created by',
    STARTED_AT: 'Started on',
    STARTED_BY: 'Started by',
    EDIT_EVENT: 'Edit this event?',
    CHANGE_TITLE: 'Change title',
    CHANGE_COVER_IMAGE: 'Change cover image',
    CHANGE_EVENT_TITLE: 'Change event title',
    CHANGE_EVENT_TITLE_PLACEHOLDER: 'Enter title',
    CHANGE_EVENT_INFO_TITLE: 'Edit live event information',
    TITLE: 'Title',
    COVER_IMAGE: 'Cover image',
    UPLOAD_IMAGE: 'Upload photo',
    EDIT_LIVE_EVENT_USERS_FOR_HOST: 'Users who can be host',
    REMOVE_IMAGE: 'Remove photo',
    CHOOSE_IMAGE: 'Choose photo',
    HOSTS: 'Host',
    HOST_LABEL: 'Host',
    USERS_FOR_HOST: 'Users who can be host',
    USERS_FOR_HOST_DESCRIPTION: 'Any one of the users in the list below can act as a host for the live event. If the current host leaves the event, another user can act as the host.',
    PARTICIPANT_LIST_HEADER_TITLE: 'Participants',
    LIVE_EVENT_END_DIALOG_TITLE: 'End live event?',
    LIVE_EVENT_END_DIALOG_DESCRIPTION: 'Do you want to end this live event?',
    LIVE_EVENT_END_DIALOG_OPTION_END: 'End live event',
    LIVE_EVENT_END_DIALOG_OPTION_EXIT: 'Exit without ending',
    TOTAL_PARTICIPANTS_COUNT: 'Total participants',
    LIVE_EVENT_SUMMARY_DIALOG_TITLE: 'Live event ended',
    PEAK_CONCURRENT_PARTICIPANTS_COUNT: 'Peak concurrent participants',
    DURATION: 'Duration',
    LIVE_EVENT_DISCONNECTED_ALERT_TITLE: 'Disconnected temporarily',
    LIVE_EVENT_DISCONNECTED_ALERT_DESCRIPTION: 'Try entering the live event again.',
    LIVE_EVENT_LIVE_PARTICIPANT_COUNT_DURATION: '1,282 watching now ∙ Started 30 mins ago',
    LIVE_EVENT_READY_BANNER_DESCRIPTION: 'Live event will begin soon.',
    LIVE_EVENT_LIVE_BANNER_HOST_MUTED_DESCRIPTION: 'Host is muted.',
    LIVE_EVENT_LIVE_BANNER_HOST_UNAVAILABLE_DESCRIPTION: 'Host is temporarily unavailable.',
    LIVE_EVENT_ENDED_DESCRIPTION: 'Live event has ended.',
    LIVE_EVENT_ENDED_DIALOG_DESCRIPTION: 'Host has ended this live event.',
    LIVE_EVENT_ENDED_ENTER_DIALOG_DESCRIPTION: 'Can\'t enter an ended live event.',
    UNKNOWN_ERROR_ALERT_TITLE: 'Oops!',
    UNKNOWN_ERROR_ALERT_DESCRIPTION: 'Something went wrong.',
  }
};